import React from 'react';
import { Map } from '@cian/frontend-newbuilding-map-component';

export const useMapRef = () => React.useRef<Map>(null);
